import AutoQueryController from "servicestack/auto-query/auto-query.controller";

export default class PromoSheetManagerController extends AutoQueryController {
  getQuery() {
    return {
      url: "QueryPromoSheets.json",
      hideLeftNav: true, // $ctrl.$page.is('gt-sm'),
      orderBy: "-CreatedOn,Id",
      criteria: {
        type: "PromoSheet",
      },
      sortOptions: {
        "CreatedOn,Id": "Created: Newest",
        "-CreatedOn,Id": "Created: Oldest",
        "Label,Id": "Label: A to Z",
        "-Label,Id": "Label: Z to A",
      },
      autoLoad: true,
      pageSize: 12,
    };
  }

  view(list, outputType = "PortableDocFormat") {
    return window.open(this.url(list, outputType));
  }

  url(list, outputType = "PortableDocFormat") {
    return $ctrl.$appConfig.resolveServiceUrl(
      `PromoSheet/${list.id}?OutputType=${outputType}`
    );
  }
}
